<form [formGroup]="accountCtrl">
	<mat-form-field class="full-width" floatLabel="never">
		<input
			#accountInput
			[formControl]="accountCtrl"
			[matAutocomplete]="auto"
			matInput
			placeholder="Account"
			(keydown)="keyPressed($event)"
		/>

		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="selected($event); keyPressed($event.option.value.businessName);"
			[displayWith]="displayFn"
		>
			<mat-option *ngIf="isLoading" fxLayoutAlign="center center">
				<mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
			</mat-option>

			<ng-container *ngIf="!isLoading">
				<mat-option *ngFor="let account of listOfAccounts" [value]="account">
					{{ !utilService.isNullOrUndefined(account.businessName) ? account.businessName : '' }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</form>
